import React from 'react';

import Button from '../../../../components/Button';

type ButtonProps = {
  onClick: () => void;
  title: string
}

const ButtonModal = ({ onClick, title }: ButtonProps) => {

  return (
    <Button
      onClick={onClick}
    >
      {title}
    </Button>
  )
}

export default ButtonModal;